/** @format */

import React from 'react';
// import { Badge } from '@mui/material';
import { Tab as RTab, Tabs as RTabs, TabList as RTabList, TabPanel as RTabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { CommonTooltip, Icons } from 'components';
import { useStyles } from './style';


const TabKeeper = ({ titles, panels, tabsErrors, tooltips, ...rest }) => {
  const classes = useStyles();

  return (
    <RTabs className={classes.root} forceRenderTabPanel {...rest}>
      <RTabList>
        {titles.map((v, k) => (
          <RTab key={k}>
            {!tabsErrors ? (
              <>
                {tooltips?.[k] ? (
                  <div className={classes.tabContainer}>
                    {v}
                    <CommonTooltip title={tooltips?.[k]}>
                      <span className={classes.infoIcon}>
                        <Icons icon='Info' color='#667585' hover='#667585' size='20' />
                      </span>

                    </CommonTooltip>
                  </div>
                ) : (
                  v
                )}
              </>
            ) : tabsErrors[k] <= 0 ? (
              v
            ) : (
              <>
                <div style={{ display: 'inline-block' }}>{v}</div>
                <div className={classes.errors}>{tabsErrors[k]}</div>
              </>
            )}
          </RTab>
        ))}
      </RTabList>
      <div className={classes.panelsContainer}>
        {panels.map((v, k) => (
          <RTabPanel key={k}>{v}</RTabPanel>
        ))}
      </div>
    </RTabs>
  );
};



export default TabKeeper;
